import { render, staticRenderFns } from "./DadosMarca.vue?vue&type=template&id=e248fab0&scoped=true&"
import script from "./DadosMarca.vue?vue&type=script&lang=ts&"
export * from "./DadosMarca.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e248fab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VImg,VSelect})
